import styled from 'styled-components'
import Theme from 'src/styles/theme'
import { FinishButton } from '../../TaxCouponEntryPage.styles'

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  padding: 15px;
`

export const Text = styled.p`
  font-size: 1rem;
`

export const Field = styled.div`
  width: 100%;

  & > label {
    height: 2rem;
  }

  & > input, select {
    height: 2.5rem;
  }
`

export const Selected = styled.div`
  margin-top: 1rem;
  min-height: 3rem;
`

export const SuggestionContainer = styled.ul`
  position: absolute;
  top: 8rem;
  width: calc(100% - 30px);
`

export const Suggestion = styled.li`
  background-color: ${Theme.colors.lightBlue};
  border-bottom: 1px solid white;
  color: white;
  cursor: pointer;
  padding: 0.5rem 1rem;

  &:hover {
    background-color: ${Theme.colors.blue};
  }
`

export const FinishSearch = styled(FinishButton)`
  align-self: center;
  margin: 0;
  height: 3rem;
`
